// extracted by mini-css-extract-plugin
export default {"boundaryContainer":"MergeBoxErrorState-module__boundaryContainer--W5nVZ"};